export default __webpack_public_path__ + "static/media/ductBank2.074251c3.jpg";